module.exports = __webpack_public_path__ + "images/patterns/light/WaveSquare.f0eb2a7cad1a79ec67dd.svg";